import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Reasons from "./components/Reasons";
import Company from "./components/Company";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <Services />
      <Reasons />
      <Company />
      <Contact />
      <Footer />
    </main>
  );
}